__turbopack_context__.v({
  "limitedHeight": "Services-module-scss-module__l_YS0q__limitedHeight",
  "normalHeight": "Services-module-scss-module__l_YS0q__normalHeight",
  "servicesContainer": "Services-module-scss-module__l_YS0q__servicesContainer",
  "servicesLabel": "Services-module-scss-module__l_YS0q__servicesLabel",
  "servicesTags": "Services-module-scss-module__l_YS0q__servicesTags",
  "tag": "Services-module-scss-module__l_YS0q__tag",
});
